/* eslint-disable */
import { FormElementBase } from "@episerver/forms-sdk";
// @ts-ignore
import React from "react";
import Tooltip from "2-core-elements/TooltipReact/Tooltip";

interface ElementCaptionProps{
    element: FormElementBase
}

export const ElementCaption = (props: ElementCaptionProps) => {
    const { element }=props;
    return (
        <label htmlFor={element.key} className="Form__Element__Caption">
            <span className="Form__Element__Caption_text">
                {element.properties.label} 
            </span>
            { element.properties.description && <Tooltip content={element.properties.description} /> }
        </label>
    );
}